import ContentCopyIcon from "@mui/icons-material/ContentCopy"
import ElectricalServicesIcon from "@mui/icons-material/ElectricalServices"
import { SvgIconProps } from "@mui/material"
import { ComponentType } from "react"

import { recognisedLctDevices } from "../../../constants/enums"
import { UNKNOWN_STATUS } from "../../../constants/generalConstants"
import {
    TT_BATTERY,
    TT_EVCP_AC,
    TT_EVCP_DC,
    TT_HP,
    TT_MULTIPLE_LCTS,
    TT_SOLAR_PV,
    TT_SOLAR_PV_BATTERY,
    TT_V2G,
} from "../../../constants/tooltips"
import {
    Battery2ThirdsIcon,
    EVChargerIcon,
    SolarPanelIcon,
    HeatPumpIcon,
    V2GIcon,
} from "../../icons/icons"

export const MULTIPLE_LCTS = "MULTIPLE_LCTS"
export type LctMetadataConfig = {
    icon: ComponentType<SvgIconProps>
    iconAriaLabel: string
    label: string
    tooltip: string
}

type TLctMetadataDispatcher = {
    [key: string]: LctMetadataConfig
}

export const LCT_TITLE_DISPATCHER = {
    [recognisedLctDevices.battery]: "Battery Storage",
    [recognisedLctDevices.evcpAc]: "EV Charge Point AC",
    [recognisedLctDevices.evcpDc]: "EV Charge Point DC",
    [recognisedLctDevices.v2g]: "EV V2G Charger",
    [recognisedLctDevices.v2gInverter]: "V2G Inverter",
    [recognisedLctDevices.solarPv]: "Solar PV",
    [recognisedLctDevices.solarPvBattery]: "Solar PV and Battery",
    [recognisedLctDevices.hp]: "Heat Pump",
}

// Used to provide config for `lctAvatar` and `lctChip` components
export const LCT_METADATA_DISPATCHER: TLctMetadataDispatcher = {
    [recognisedLctDevices.battery]: {
        icon: Battery2ThirdsIcon,
        iconAriaLabel: LCT_TITLE_DISPATCHER[recognisedLctDevices.battery],
        label: LCT_TITLE_DISPATCHER[recognisedLctDevices.battery],
        tooltip: TT_BATTERY,
    },
    [recognisedLctDevices.evcpAc]: {
        icon: EVChargerIcon,
        iconAriaLabel: LCT_TITLE_DISPATCHER[recognisedLctDevices.evcpAc],
        label: LCT_TITLE_DISPATCHER[recognisedLctDevices.evcpAc],
        tooltip: TT_EVCP_AC,
    },
    [recognisedLctDevices.evcpDc]: {
        icon: EVChargerIcon,
        iconAriaLabel: LCT_TITLE_DISPATCHER[recognisedLctDevices.evcpDc],
        label: LCT_TITLE_DISPATCHER[recognisedLctDevices.evcpDc],
        tooltip: TT_EVCP_DC,
    },
    [recognisedLctDevices.v2g]: {
        icon: V2GIcon,
        iconAriaLabel: LCT_TITLE_DISPATCHER[recognisedLctDevices.v2g],
        label: LCT_TITLE_DISPATCHER[recognisedLctDevices.v2g],
        tooltip: TT_V2G,
    },
    [recognisedLctDevices.v2gInverter]: {
        icon: EVChargerIcon,
        iconAriaLabel: LCT_TITLE_DISPATCHER[recognisedLctDevices.v2gInverter],
        label: LCT_TITLE_DISPATCHER[recognisedLctDevices.v2gInverter],
        tooltip: TT_V2G,
    },
    [recognisedLctDevices.solarPv]: {
        icon: SolarPanelIcon,
        iconAriaLabel: LCT_TITLE_DISPATCHER[recognisedLctDevices.solarPv],
        label: LCT_TITLE_DISPATCHER[recognisedLctDevices.solarPv],
        tooltip: TT_SOLAR_PV,
    },
    [recognisedLctDevices.solarPvBattery]: {
        icon: SolarPanelIcon,
        iconAriaLabel:
            LCT_TITLE_DISPATCHER[recognisedLctDevices.solarPvBattery],
        label: LCT_TITLE_DISPATCHER[recognisedLctDevices.solarPvBattery],
        tooltip: TT_SOLAR_PV_BATTERY,
    },
    [recognisedLctDevices.hp]: {
        icon: HeatPumpIcon,
        iconAriaLabel: LCT_TITLE_DISPATCHER[recognisedLctDevices.hp],
        label: LCT_TITLE_DISPATCHER[recognisedLctDevices.hp],
        tooltip: TT_HP,
    },
    [MULTIPLE_LCTS]: {
        icon: ContentCopyIcon,
        iconAriaLabel: "Icon avatar for multiple LCTs",
        label: "",
        tooltip: TT_MULTIPLE_LCTS,
    },
    [UNKNOWN_STATUS]: {
        icon: ElectricalServicesIcon,
        iconAriaLabel: "Unrecognised Lct",
        label: "",
        tooltip: "",
    },
}
